import styled from 'styled-components/macro';

const AvatarWrapper = styled.div`
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #efecf6;
  border: 1px solid #e2e0eb;
`;

export default AvatarWrapper;
